const parseQuery = (query) => query
  .split('&')
  .map((item) => {
    const parameter = item.split('=');
    const key = parameter[0].replace('?', '');
    const value = parameter[1];

    return {
      [key]: value,
    };
  })
  .reduce((acc, item) => {
    acc[Object.keys(item)[0]] = Object.values(item)[0];

    return acc;
  }, {});

export const getParameterFromQuery = (parameter, query) => parseQuery(query)[parameter] || null;
export default parseQuery;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/parseQuery.js